var _path, _path2, _path3, _path4;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgTelegramDesk(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 25,
    viewBox: "0 0 24 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12 0.173462C5.37253 0.173462 0 5.54599 0 12.1735C0 18.8009 5.37253 24.1735 12 24.1735C18.6275 24.1735 24 18.8009 24 12.1735C24 5.54599 18.6275 0.173462 12 0.173462Z",
    fill: "#5B78FF"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M17.839 7.07624L15.6956 17.8827C15.6956 17.8827 15.3959 18.6321 14.5715 18.2724L9.62545 14.4804L7.82695 13.6112L4.79939 12.5919C4.79939 12.5919 4.33476 12.4271 4.28976 12.0674C4.24476 11.7077 4.81439 11.5129 4.81439 11.5129L16.8496 6.79161C16.8496 6.79161 17.8389 6.35699 17.8389 7.07643",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M9.24546 17.7612C9.24546 17.7612 9.10109 17.7477 8.92109 17.1781C8.74137 16.6085 7.82703 13.611 7.82703 13.611L15.0962 8.99472C15.0962 8.99472 15.5159 8.73991 15.5009 8.99472C15.5009 8.99472 15.5758 9.03972 15.3509 9.24953C15.1262 9.45944 9.64062 14.3904 9.64062 14.3904",
    fill: "#C2CFE0"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M11.5219 15.9344L9.56561 17.7181C9.56561 17.7181 9.41261 17.8341 9.24536 17.7614L9.61999 14.4482",
    fill: "#C2CFE0"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTelegramDesk);
export default __webpack_public_path__ + "static/media/Telegram-desk.8a3f004e.svg";
export { ForwardRef as ReactComponent };